import React from 'react';
import './NameItem.scss';

export default ({ children }) => <span styleName="name">{children}</span>;
